import { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    IconButton
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface CreateGroupDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (groupName: string) => void;
}

function CreateGroupDialog({
    open,
    onClose,
    onConfirm,
}: CreateGroupDialogProps) {
    const [groupName, setGroupName] = useState('');

    const handleConfirm = () => {
        if (groupName.trim()) {
            onConfirm(groupName.trim());
            setGroupName('');
        }
    };

    const handleClose = () => {
        setGroupName('');
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    Créer un nouveau groupe
                    <IconButton onClick={handleClose} size="small">
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent>
                <TextField
                    autoFocus
                    fullWidth
                    label="Nom du groupe"
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                    placeholder="Ex: TEMPLATE EMAIL"
                    onKeyPress={(e) => {
                        if (e.key === 'Enter' && groupName.trim()) {
                            handleConfirm();
                        }
                    }}
                    sx={{ mt: 2 }}
                />
            </DialogContent>

            <DialogActions sx={{ p: 2 }}>
                <Button onClick={handleClose}>
                    Annuler
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    disabled={!groupName.trim()}
                    sx={{ bgcolor: '#556ee6' }}
                >
                    Créer
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateGroupDialog;
